import { AUTH_HOOK_CONTEXT_ERROR } from "@constants/constants";
import { use } from "react";

import { AuthContext } from "./auth-context";

export const useAuth = () => {
	const ctx = use(AuthContext);

	if (ctx === undefined) {
		throw new Error(AUTH_HOOK_CONTEXT_ERROR);
	}

	return ctx;
};
